<template>
  <div ref="wraper" class="product-voyage">
    <div class=" main-body">
      <h3 class="main-title">
        航次选择
        <span class="main-title__sub">本船共 {{ voyageData.length }} 个航次</span>
      </h3>
      <ul class="month-tabs">
        <li
          v-for="(monthStr, month) in monthNavs"
          :key="month"
          class="tab"
          :class="{
            'is-active': month == currentMonth,
          }"
          @click="$emit('update:currentMonth', month)"
        >
          {{ monthStr }}
        </li>
      </ul>
      <ul class="packages">
        <li
          v-for="voyage in selectedVoyages"
          :key="voyage.id"
          class="package py-4 h-[100px]"
          :class="{
            'is-active': currentVoyage.id === voyage.id,
          }"
          @click="handleSelectVoyage(voyage)"
        >
          <div class="package-title">{{ voyage.date | formatDate }}</div>
          <div class="package-num">{{ voyage.last_stock | mapStockText }}</div>
          <div class="package-price text-price">¥ {{ voyage.price }}起/人</div>
          <span v-if="voyage.date_tag" class="absolute left-0 top-0 px-2 rounded-tl-[6px] rounded-br-xl bg-gradient-to-r from-[#f2007d] to-[#f2b203] text-xs text-white">{{
            voyage.date_tag.name
          }}</span>
        </li>
      </ul>

      <div class="package-detail">
        <div class="border-t pt-5 z-[1]">
          <div class="flex text-dark text-sm">
            <span >报名截止时间:</span>
            <span class="ml-2">{{ currentVoyage.end_time }}</span>
          </div>
          <div class="flex text-dark text-sm mt-2.5"><span>付款规则:</span><span class="ml-2">{{ currentVoyage.installment_label }}</span></div>
        </div>
        <!-- <ul class="pay-progress">
          <li v-for="i in 5" :key="i" class="pay-progress-item">
            <span>定金: 立即支付</span>
            <span class="percent">10%</span>
          </li>
        </ul> -->
        <!-- <div class="progress">
          <PayProgress
            v-if="currentVoyage.installment == 1"
            :data="currentVoyage.installment_conf"
          >
            <template #value="{data}">
              <template v-if="data.type == 1">{{ data.rate_value }}%</template>
              <template v-if="data.type == 2"
                >￥{{ data.rate_value }}元/人</template
              >
            </template>
          </PayProgress>
        </div> -->
      </div>
      <v-loading
        :active="loading"
        :container="getWraper"
        :is-full-page="false"
      />
    </div>
  </div>
</template>

<script>
import { dayjs } from "@/utils/helpers";
import { defineComponent } from "@nuxtjs/composition-api";

export default defineComponent({
  name: "DetailVoyage",
  filters: {
    mapStockText(value) {
      if (value > 10) {
        return "库存充足";
      }
      if (value > 0) {
        return `仅剩${value}间`;
      }
      return "1小时内确认";
    },
    mapPaymentAmontText(voyage) {
      return voyage.installment == 1
        ? `订单总金额可分${voyage.installment_conf.length}次支付`
        : "订单总金额全款支付";
    },
    formatDate(date) {
      if (!date) return "";

      const dateRef = dayjs(date, "YYYY-MM-DD");
      const day = dateRef.date();
      const weekDay = ["日", "一", "二", "三", "四", "五", "六"][dateRef.day()];

      return `${day}日/周${weekDay}`;
    },
    mapMethodText(methods = []) {
      if (methods.length == 1) {
        return `仅支持${methods[0]}`;
      }
      return "线上支付和线下汇款均支持";
    },
  },
  props: {
    loading: Boolean,
    voyageData: {
      type: Array,
      default: () => [],
    },
    currentVoyage: {
      type: Object,
      default: () => ({})
    },
    normalizesVoyageDataByMonth: {
      type: Object,
      default: () => ({})
    },
    selectedVoyages: {
      type: Array,
      default: () => ([])
    },
    monthNavs: {
      type: Object,
      default: () => ({})
    },
    currentMonth: String,
  },

  setup(props) {
    // const voyageData = ref({});
    // const currentVoyage = ref({
    //   id: '',
    //   installment_conf: []
    // })

    // const {fetch, fetchState} = useFetch( async () => {
    //   let {code, data, msg} = await getProductDateById({product_no: props.productNo});
    //   if(code !== REQUEST_CODES.ERROR_OK){
    //     throw new Error(msg)
    //   }
    //   voyageData.value = data;
    // })
    // const { voyageData, currentVoyage, setCurrentVoyage, fetchVoyageData } =
    //   useVoyage(props);

    // fetchVoyageData();

    return {
      // voyageData,
      // currentVoyage,
      // setCurrentVoyage,
    };
  },
  // components: { PayProgress },
  data() {
    return {
      // loading: false,
      // currentMonth: "",
      // setStockLoading: false,
      // currentVoyage: {
      //   installment_conf:[]
      // },
      // voyageData: {
      // }
    };
  },
  // async fetch(){
  //   const voyageData = ref({})

  // },
  computed: {
    // ...mapState("product/booking", [
    //   "voyageData",
    //   "currentVoyage",
    //   "bookingData"
    // ]),
    /**
     * 航期数据根据月份分组
     * @example
     * {
     *  2020-1: {}
     * }
     */
    // normalizesVoyageDataByMonth() {
    //   return groupBy(this.voyageData, (voyage) => {
    //     // let [year, month] =
    //     return voyage.date.split("-").slice(0, 2).join("-");
    //   });
    // },
    /**
     * 航期月份
     * @example
     * {2020-1: '2021年1月'}
     */
    // monthData() {
    //   return Object.keys(this.normalizesVoyageDataByMonth).reduce(
    //     (result, month) => {
    //       let [Y, M] = month.split("-");
    //       result[month] = `${Y}年${M}月`;
    //       return result;
    //     },
    //     {}
    //   );
    // },

    // selectedVoyages() {
    //   if (!this.currentMonth) return;
    //   return this.normalizesVoyageDataByMonth[this.currentMonth];
    // },
    // bookingNo() {
    //   let { booking_no } = this.$route.query;
    //   return booking_no;
    // },
  },
  // watch: {
  //   monthData: {
  //     immediate: true,
  //     handler(val) {
  //       let months = Object.keys(val);
  //       if (!months.length) return;
  //       let { bookingData } = this;

  //       if (isEmpty(bookingData)) {
  //         this.currentMonth = months[0];
  //         this.$nextTick(() => {
  //           if (this.selectedVoyages.length > 0 && !this.currentVoyage.id) {
  //             // this.currentVoyage = this.selectedVoyages[0];
  //             let currentVoyage = this.selectedVoyages[0] || {};
  //             this.setCurrentVoyage(currentVoyage);
  //             this.getProductStock({
  //               spd_id: currentVoyage.id,
  //               product_no: this.productNo,
  //             });
  //           }
  //         });
  //       } else {
  //         let currentVoyage = this.voyageData.find(
  //           (item) => item.date === bookingData.params.date
  //         );
  //         let currentMonth = currentVoyage.date
  //           .split("-")
  //           .slice(0, 2)
  //           .join("-");
  //         this.currentMonth = currentMonth;
  //         this.setCurrentVoyage(currentVoyage);
  //         this.getProductStock({
  //           spd_id: currentVoyage.id,
  //           product_no: this.productNo,
  //         });
  //       }
  //     },
  //   },
  // },
  // async mounted() {
  //   this.loading = true;
  //   let { code, msg } = await this.getProductDateById({
  //     product_no: this.productNo,
  //     bookingNo: this.bookingNo,
  //   });
  //   this.loading = false;
  //   if (code !== 10000) {
  //     this.$message.error(msg);
  //     // this.$notify({ group: "msg", text: msg, type: MESSAGE_TYPES.ERROR });
  //     return;
  //   }
  // },
  mounted() {
    // this.$loading.show({
    //   // Optional parameters
    //   container: this.fullPage ? null : this.$refs.wraper,
    //   canCancel: false,
    //   onCancel: this.onCancel,
    // })
  },
  methods: {
    getProductStock() {},
    getWraper() {
      return this.$refs.wraper;
    },
    // ...mapMutations("product/booking", ["setCurrentVoyage"]),
    // ...mapActions("product/booking", ["getProductDateById", "getProductStock"]),
    handleMonthClick(month) {
      this.currentMonth = month;
    },
    handleSelectVoyage(currentVoyage) {
      // this.setCurrentVoyage(currentVoyage);
      this.$emit('update:currentVoyage', currentVoyage)
      // this.getProductStock({
      //   spd_id: currentVoyage.id,
      //   product_no: this.productNo,
      // });
    },
  },
})
</script>

<style lang="scss" scoped>
.main-body {
  position: relative;
}
.main-title {
  margin-bottom: 5px;
  font-size: 20px;
  color: $color-black-2;
  font-weight: 500;
}
.main-title__sub {
  color: #868E96;
  font-size: 13px;
}
.month-tabs {
  display: flex;
  flex-wrap: wrap;
  margin: 0 -5px;
}
.month-tabs .tab {
  flex-shrink: 0;
  padding: 4px 8px;
  cursor: pointer;
  transition: all $primary-transition;
  border-radius: 2px;
  margin: 5px 7px;
  border-radius: 20px;
  background-color: #e7e8ed;
}
.month-tabs .tab:hover {
  background-color: rgba($color: $color-grey-8, $alpha: 0.8);
  color: $color-black-2;
}
.month-tabs .tab.is-active {
  background: $color-black-2;
  color: $color-white;
}
.packages {
  display: flex;
  margin-top: 18px;
  flex-wrap: wrap;
}
.packages .package {
  cursor: pointer;
  position: relative;
  width: 120px;
  border-radius: 6px;
  border: $default-border;
  text-align: center;
  user-select: none;
  transition: border-color $primary-transition;
  overflow: hidden;
  flex-shrink: 0;
  margin: 0 10px 10px 0;
  font-size: 15px;
}
.packages .package:first-child {
  margin-left: 0;
}
.packages .package-title {
  color: $important-text-color;
  font-weight: 500;
}
.packages .package-num {
  color: $color-grey-4;
}
.packages .package-price {
  font-weight: 500;
}
.packages .package .holiday-tag {
  position: absolute;
  left: 0;
  top: 0;
  font-size: 12px;
  padding: 0 8px;
  height: auto;
}
.packages .package.is-active, .packages .package:hover {
  --tw-bg-opacity: 1;
  background-color: rgba(0, 94, 220, var(--tw-bg-opacity));
  --tw-bg-opacity: 0.1;
  background-color: #f4f4f4;
  border-color: $color-black-2;
}
.packages .package.is-active {
  overflow: hidden;
}
.packages .package.is-active::before {
  content: "";
  position: absolute;
  right: -24px;
  bottom: -30px;
  border: 24px solid transparent;
  border-bottom-color: $color-black-2;
  transform: rotate(135deg);
}
.packages .package.is-active::after {
  content: "";
  position: absolute;
  right: 3px;
  bottom: 6px;
  width: 10px;
  height: 5px;
  border: 1px solid #fff;
  border-top: 0;
  border-right: 0;
  transform: rotate(-45deg);
}
.package-detail {
  @include clearfix;
  margin-top: 10px;
}
.package-detail .progress {
  float: left;
  margin-left: 50px;
  width: 230px;
}
.package-detail .progress ::v-deep li {
  margin-bottom: 4px;
}
</style>
